import { createUseStyles } from '@glu/theming';

const styles = {
  root: {
    borderRadius: 0,
    backgroundColor: ({ color }) => color,
    height: '100%',
    width: ({ amount, total }) => `${(amount / total) * 100}%`,
    marginRight: 2,

    '&:first-child': {
      borderTopLeftRadius: 100,
      borderBottomLeftRadius: 100
    },

    '&:last-child': {
      borderTopRightRadius: 100,
      borderBottomRightRadius: 100,
      marginRight: 0
    }
  }
};

export default createUseStyles(styles);
